import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface SpinnerState {
  loadId: string | null;
  loading: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class Spinner {
  apiInfo: SpinnerState = { loadId: null, loading: false };
  apiLoadingSource = new BehaviorSubject<SpinnerState>({ loadId: ' ', loading: false });
  apiLoading$ = this.apiLoadingSource.asObservable();

  //show bootstrap spinner button that will be used on forms
  showSpinnerButton(): void {
    this.apiInfo.loading = true;
    const loader = document.getElementById('loading-spinner');
    if (loader) {
      //update api loader observable that can be subscribed to from all components to know when an api call is present
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.remove('d-none');
    }
  }

  //hide bootstrap spinner button that will be used on forms
  hideSpinnerButton(): void {
    this.apiInfo.loading = false;
    this.apiInfo.loadId = null;
    const loader = document.getElementById('loading-spinner');
    if (loader) {
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.add('d-none');
    }
  }

  showPdfSpinner(): void {
    this.apiInfo.loading = true;
    const loader = document.getElementById('pdf-spinner');
    if (loader) {
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.remove('d-none');
    }
  }

  hidePdfSpinner(): void {
    this.apiInfo.loading = false;
    this.apiInfo.loadId = null;
    const loader = document.getElementById('pdf-spinner');
    if (loader) {
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.add('d-none');
    }
  }

  showCheckDetailSpinner(): void {
    this.apiInfo.loading = true;
    const loader = document.getElementById('check-loader');
    if (loader) {
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.remove('d-none');
    }
  }

  hideCheckDetailSpinner(): void {
    this.apiInfo.loading = false;
    const loader = document.getElementById('check-loader');
    if (loader) {
      this.apiLoadingSource.next(this.apiInfo);
      loader.classList.add('d-none');
    }
  }

  //show api spinner
  showApiLoader(loadId: string, className?: string): void {
    this.apiInfo.loadId = loadId;
    this.apiInfo.loading = true;
    const apiLoader = document.getElementById('api-loader');
    if (apiLoader) {
      this.apiLoadingSource.next(this.apiInfo);
      apiLoader.classList.remove('d-none');
      if (className) {
        apiLoader.classList.add(className);
      }
    }
  }

  //hide api spinner
  hideApiLoader(): void {
    this.apiInfo.loading = false;
    this.apiInfo.loadId = null;
    const apiLoader = document.getElementById('api-loader');
    if (apiLoader) {
      this.apiLoadingSource.next(this.apiInfo);
      apiLoader.classList.add('d-none');
      apiLoader.classList.remove('load-app');
    }
  }

  showEasyApiLoader(): void {
    const apiLoader = document.getElementById('load-api');
    if (apiLoader) {
      apiLoader.classList.remove('d-none');
    }
  }

  hideEasyApiLoader(): void {
    const apiLoader = document.getElementById('load-api');
    if (apiLoader) {
      apiLoader.classList.add('d-none');
    }
  }

  // Helper method for making a clicked anchor or button element disabled
  makeElementDisabled(elem: HTMLAnchorElement | HTMLButtonElement | HTMLElement): void {
    elem.classList.add('is-waiting');
  }

  // Helper method for enabling a clicked anchor or button element
  makeElementEnabled(elem: HTMLAnchorElement | HTMLButtonElement | HTMLElement): void {
    elem.classList.remove('is-waiting');
  }

  hideLoaders(): void {
    this.hideApiLoader();
    this.hideSpinnerButton();
  }
}
